module.exports = __webpack_public_path__ + "static/img/copter_01.1337088.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/video/copter_01.png
// module id = A1C9
// module chunks = 0